import styled, { css } from 'styled-components'

const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`

const Content = styled.section`
  ${({ theme }) => css`
    max-width: 56rem;
    padding: ${theme.spacing(5)} ${theme.spacing(10)};
    border: 0.2rem solid ${theme.palette.grey[300]};
    border-radius: ${theme.spacing(0.5)};
    text-align: center;
    background-color: ${theme.palette.white};
  `}
`

const Footer = styled.footer`
  ${({ theme }) => css`
    padding-top: ${theme.spacing(1.5)};
    border-top: 0.1rem solid ${theme.palette.grey[300]};
    text-align: left;
  `}
`

export default {
  Main,
  Content,
  Footer,
}
